import { t, Trans } from '@lingui/macro'
import { Box, FormLabel, MenuItem } from '@mui/material'
import { useFormikContext } from 'formik'
import { FC } from 'react'
import { TextFieldWithFormik } from '../common-components/with-formik/TextFieldWithFormik'
import { FirstLoginFlowFormikProps } from './index'

import { useLingui } from '@lingui/react'
import CustomButton from '../common-components/CustomButton'
import { getTranslationIdFromSalesforceApiValue } from '../common/translationsCommon'
import { GoalOption } from './useGoalOption'

interface GoalSelectionProps {
  goalOptions: GoalOption[]
}

export const GoalSelection: FC<GoalSelectionProps> = ({ goalOptions }) => {
  const { _ } = useLingui()
  const {
    values, handleChange, handleBlur, setFieldValue, validateForm, setFieldTouched
  } = useFormikContext<FirstLoginFlowFormikProps>()

  const onClickContinue = async (): Promise<void> => {
    const errors = await validateForm()
    if (errors.goal) {
      setFieldTouched('goal', true)
    } else {
      setFieldValue('goalCompleted', true)
    }
  }

  return (
    <>
      <FormLabel>
        <Trans>FIRST_LOGIN_FLOW_WHAT_ARE_YOU_LOOKING_FOR_LABEL</Trans>
      </FormLabel>
      <TextFieldWithFormik
        select
        name='goal'
        value={values.goal}
        onChange={handleChange}
        onBlur={handleBlur}
        required
      >
        {goalOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {_(t`${getTranslationIdFromSalesforceApiValue(option.label)}`)}
          </MenuItem>
        ))}
      </TextFieldWithFormik>
      <Box sx={{ display: 'flex', gap: '16px', mt: '24px' }}>
        <CustomButton
          onClick={onClickContinue}
        >
          <Trans>FIRST_LOGIN_FLOW_CONTINUE_BUTTON</Trans>
        </CustomButton>
        {values.goal && (
          <CustomButton
            variant='outlined'
            onClick={() => {
              setFieldValue('goal', '')
              setFieldValue('goalCompleted', false)
            }}
          >
            <Trans>FIRST_LOGIN_FLOW_BACK_BUTTON</Trans>
          </CustomButton>
        )}
      </Box>
    </>
  )
}
